import ChartingHighchartsBaseController from './charting_highcharts_base_controller';

export default class extends ChartingHighchartsBaseController {
  buildConfig() {
    const config = super.buildConfig();
    config.colorAxis = {
      minColor: this.theme('color-base-200'),
      maxColor: this.theme('color-accent'),
      ...config.colorAxis
    };
    return config;
  }

  // eslint-disable-next-line class-methods-use-this -- polymorphic override
  resolveClickValue(point, _member) {
    return point.name || point.x;
  }
}
